import { render, staticRenderFns } from "./LabelWithColour.vue?vue&type=template&id=1871e20e&scoped=true&"
import script from "./LabelWithColour.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LabelWithColour.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LabelWithColour.vue?vue&type=style&index=0&id=1871e20e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871e20e",
  null
  
)

export default component.exports